<template>
    <rkm-area
        title="Cotas"
        type="fieldset"
        class="pt-0"
    >
        <Form :data="data" />

    </rkm-area>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    props: {
        data: { type: Object, required: true },
    },
}
</script>